import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectedLocale } from '~/components/locale/utils';
import currencyFormatter from '~/libs/currency-formatter';

const useFormatTournamentCurrency = (currencyCode: string | null | undefined) => {
	const { locale } = useSelector(selectedLocale) as { locale: string };

	const formatTournamentCurrency = useCallback(
		(number: number | null | undefined) =>
			(typeof number === 'number' && locale && currencyCode
				? currencyFormatter.format(number, currencyCode, locale, Number.isInteger(number))
				: '') as string,
		[locale, currencyCode]
	);

	return formatTournamentCurrency;
};

export default useFormatTournamentCurrency;
